<template>
    <div class="tel fix">
        <span class="tit fl">竞投咨询</span>
        <div class="fl fix wx-font">
            <i class="icon-wx"></i>
            <div class="codeWx">扫码加专属客服微信
                <div class="codeBox" v-if="contactObject">
                    <img :src="contactObject.bid_ask_wechat_pic" alt="">
                </div>
            </div>
        </div>
        <div class="fl fix tel-font">
            <i class="icon-phone"></i>
            <template v-if="contactObject">{{contactObject.bid_ask_phone}}</template>
        </div>
    </div>
</template>

<script>
export default {
    name: "contact",
    props:{
        contactData:{
            type:Object
        }
    },
    data(){
        return{
            contactObject:null
        }
    },
    watch:{
        contactData:{
            immediate: true,
            handler(val) {
                this.contactObject = val
            }
        }
    }
}
</script>

<style scoped lang="scss">
.tel {
    width: 1180px;
    height: 40px;
    background: #eaf5e7;
    border-radius: 4px;
    border: 1px solid #329d15;
    line-height: 40px;
    flex: 1;
    .tit{font-size: 16px;color:#329d15;font-weight: bold;margin-left: 20px;}
}
.wx-font{
    background:url("../../assets/imgs/icon_code.png") no-repeat right center;padding-right: 16px;margin-left: 40px;
    font-size: 14px;color:#329d15;font-weight: bold;
    .icon-wx{width:16px;height: 16px;background:#329d15 url("../../assets/imgs/icon_wx_w.png") no-repeat center;background-size: 12px 12px;display:inline-block;margin-right: 10px;border-radius: 50%;vertical-align: -3px;}
    .codeWx{display:inline-block;position: relative;}
    .codeBox{position: absolute;background:#fff;z-index: 1;display:none;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);padding:10px;right:-80px;top:40px;
        img{width:80px;height: 80px;}
    }
    &:hover .codeBox{display:block;}
}
.tel-font {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #329d15;
    margin-left: 86px;
    .icon-phone{width:16px;height: 16px;display:inline-block;background:#329d15 url("../../assets/imgs/icon_phone.png") no-repeat center;background-size:8px;margin-right: 10px;vertical-align: -3px;border-radius: 50%;}
}
</style>